import AxiosInterceptor from "../utils/AxiosInterceptor";

const tournamentsTeamsService = {
  getAllTournamantTeams: (id) => AxiosInterceptor().get(`/tournaments/${id.id}/teams`),
  getOneTeam: (id) => AxiosInterceptor().get(`/tournaments/team/${id.id}`),
  updateTeam: (value) => AxiosInterceptor().post(`/tournaments/updateTeam`,value),
//   add: (value) => AxiosInterceptor().post(`${BASE}/addUser`, value),
//   delete: (value) => AxiosInterceptor().post(`${BASE}/deleteUser`, value),
//   changeStatus: (value) =>
//     AxiosInterceptor().post(`${BASE}/changeStatus`, value),
};

export default tournamentsTeamsService;
